@use "@sass/helper";

.searchBox {
  border-left: "1px solid #ccc";
  outline: "none";
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  &:focus {
    box-shadow: none;
  }
}

.selectBox {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  &:focus {
    box-shadow: none;
  }
}

.searchResults {
  font-size: 0.85rem;
  :global {
    .list-group-item {
      padding: 3px 1em;
      &:first-child {
        border-radius: 0px;
      }
      &:hover {
        background: #dddfe3;
      }
      a {
        text-decoration: none;
        color: #333;
      }
    }
  }
  position: absolute;
  top: 100%;
  z-index: helper.$zindex-dropdown;
  max-height: 60vh;
  overflow-y: auto;
  width: 100%;
  overflow-x: hidden;
}

.onRight {
  right: 0em;
  width: 40vw;
  min-width: 400px;
}

.highlighted {
  background: #c4c8cf;
}
